import React, { FC } from 'react'
import { getValueListBgColor } from '../../../utils/background-util'

interface Props {
  milestoneColor: string
  contentDesc: string
  milestoneMonthDesc: string
  leftAligned: boolean
}

const RowComponent = ({ contentDesc, milestoneMonthDesc, milestoneColor, leftAligned }: Props) => {
  return (
    <div
      className={`Journey u-flex u-posRelative ${
        leftAligned ? 'u-lg-after5of12 Journey-Left' : 'u-lg-before5of12'
      }`}>
      {!leftAligned && <div className='u-size1of12 u-md-hidden u-sm-hidden' />}
      <h3
        className={`Journey-step step-right u-flex u-flexJustifyCenter u-flexAlignItemsCenter u-sizeFull u-textColorWhite ${getValueListBgColor(
          milestoneColor
        )} u-textCenter u-paddingHoriz2gu u-size1of12 ${leftAligned ? 'u-lg-hidden' : ''}`}>
        {milestoneMonthDesc}
      </h3>
      <div
        className={`Journey-content u-md-Journey-content u-sm-Journey-content right-aligned u-md-size1of12 u-sm-size1of12 u-flex u-flexJustifyBetween u-paddingVert4gu u-sm-paddingLeft2gu u-paddingLeft6gu u-posRelative u-size1of12 ${
          leftAligned ? 'u-lg-hidden' : ''
        }`}>
        <div className='Journey-text u-size10of12'>
          <div className='Content content-block'>
            <p className='cmsTextColorPurple u-textColorDuff'></p>
          </div>
        </div>
      </div>
      <div className='Journey-text u-size9of12 u-md-size10of12 u-md-marginTop2gu u-marginTop4gu u-sm-marginTop2gu'>
        <div className='Content content-block u-border u-bgColorLight u-lg-marginRight7gu'>
          <div className='u-paddingHoriz3gu u-paddingVert6gu'>
            <div dangerouslySetInnerHTML={{ __html: contentDesc }}></div>
          </div>
        </div>
      </div>
      {leftAligned && (
        <>
          <div
            className={`Journey-content u-md-Journey-content u-sm-Journey-content right-aligned u-md-size1of12 u-sm-size1of12 u-flex u-flexJustifyBetween u-paddingVert4gu u-sm-paddingLeft2gu u-paddingLeft6gu u-posRelative u-size1of12 ${
              leftAligned ? 'u-md-hidden u-sm-hidden' : ''
            }`}>
            <div className='Journey-text u-size10of12'>
              <div className='Content content-block'>
                <p className='cmsTextColorPurple u-textColorDuff'></p>
              </div>
            </div>
          </div>
          <h3
            className={`Journey-step step-right u-flex u-flexJustifyCenter u-flexAlignItemsCenter u-sizeFull u-textColorWhite ${getValueListBgColor(
              milestoneColor
            )} u-textCenter u-paddingHoriz2gu u-size1of12 u-md-hidden u-sm-hidden`}>
            {milestoneMonthDesc}
          </h3>
        </>
      )}
    </div>
  )
}

export default RowComponent
